import React, { useState, useEffect } from 'react'
import { showToast } from '@provi/provi-components'

import { LoadingSkeleton } from '../../../components/LoadingSkeleton'
import { getIncomeTaxUrl, getFiscalYears } from '../../../services/api'
import openDownload from '../../../utils/openDownload'

import * as S from './styles'

export const IncomeTaxYearModal = ({ isOpen, onClose }) => {
  const [availableYears, setAvailableYears] = useState([])
  const [selectedYear, setSelectedYear] = useState(null)

  const [isLoadingYears, setIsLoadingYears] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)

  useEffect(() => {
    if (!isOpen) return
    const handleKeyDown = e => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, onClose])

  useEffect(() => {
    if (!isOpen) {
      setAvailableYears([])
      setSelectedYear(null)
      return
    }

    const fetchYears = async () => {
      setIsLoadingYears(true)
      try {
        const years = await getFiscalYears()

        if (years && years.length > 0) {
          setAvailableYears(years)
          setSelectedYear(years[years.length - 1])
        } else {
          setAvailableYears([])
          setSelectedYear(null)
        }
      } catch (error) {
        const currentYear = Number(new Date().getFullYear()) - 1
        setSelectedYear(currentYear)
        setAvailableYears([currentYear])
      } finally {
        setIsLoadingYears(false)
      }
    }

    fetchYears()
  }, [isOpen])

  const handleDownload = async () => {
    if (!selectedYear) return

    setIsDownloading(true)
    try {
      const response = await getIncomeTaxUrl({ fiscalYear: selectedYear })

      const urlToDownload = response?.urlIncomeTax || response

      if (urlToDownload) {
        openDownload(urlToDownload, `informe-rendimentos-${selectedYear}.pdf`)
        onClose()
      } else {
        throw new Error('URL not found in response')
      }
    } catch (error) {
      showToast('Erro ao gerar o informe. Tente novamente mais tarde.', 'error')
    } finally {
      setIsDownloading(false)
    }
  }

  if (!isOpen) return null

  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContent onClick={e => e.stopPropagation()}>
        <S.Header>
          <S.ModalTitle>Selecione o Ano Calendário</S.ModalTitle>
          <S.CloseButton onClick={onClose}>X</S.CloseButton>
        </S.Header>

        <LoadingSkeleton isLoading={isLoadingYears} repeat={1} containerHeight="60px" hasParagraph>
          {availableYears.length > 0 ? (
            <S.YearSelect value={selectedYear ?? ''} onChange={e => setSelectedYear(Number(e.target.value))}>
              {availableYears.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </S.YearSelect>
          ) : (
            <p style={{ fontFamily: 'Montserrat', marginBottom: '20px' }}>Nenhum ano calendário disponível no momento.</p>
          )}
        </LoadingSkeleton>

        <S.DownloadButton
          onClick={handleDownload}
          disabled={isLoadingYears || isDownloading || !selectedYear || availableYears.length === 0}
        >
          {isDownloading ? (
            <>
              <S.Spinner />
              Gerando documento...
            </>
          ) : (
            'Baixar Informe'
          )}
        </S.DownloadButton>
      </S.ModalContent>
    </S.ModalOverlay>
  )
}
